import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
function lateralSpacing(props) {
    switch (props.$spacingDirection) {
        case 'left':
            return `margin-left: ${theme.spacing.sm}`;
        case 'right':
            return `margin-right: ${theme.spacing.sm}`;
        default:
            return undefined;
    }
}
export const Copy = styled.span `
  font: ${theme.fontRole.bodySm};
  ${lateralSpacing};
`;
